import React from "react";
import { NavLink } from "react-router-dom";
import { Button, Tooltip, VisuallyHidden } from "@chakra-ui/react";

interface INavButton {
  navType: "link" | "button";
  helperText: string;
  link?: string;
  onClick?: () => void;
}

/**
 * Component to display a standardized kind of navbutton.
 * @param param0
 * @returns
 */
function NavButton({
  navType,
  helperText,
  link,
  onClick,
  children,
}: React.PropsWithChildren<INavButton>) {
  if (!link && !onClick) return <React.Fragment />;
  const buttonProps =
    navType === "link" ? { as: NavLink, to: link } : { onClick };
  return (
    <Tooltip hasArrow label={helperText}>
      <Button variant="ghost" {...buttonProps}>
        {children}
        <VisuallyHidden>{helperText}</VisuallyHidden>
      </Button>
    </Tooltip>
  );
}

export { NavButton };
